var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-insight-card"},[_c('div',{staticClass:"insight-images"},[_c('img',{staticClass:"insight-images__image",attrs:{"src":_vm.image,"alt":"none"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }